import brandPage from './brandPage/actions'
import cancelSubscriptionPage from './cancelSubscriptionPage/actions'
import careersPage from './careersPage/actions'
import collectionPage from './collectionPage/actions'
import collectionLandingPage from './collectionLandingPage/actions'
import extrasPage from './extrasPage/actions'
import fragranceOfTheMonthPage from './fragranceOfTheMonthPage/actions'
import invitePage from './invitePage/actions'
import mainPage from './mainPage/actions'
import myOrdersPage from './myOrdersPage/actions'
import noteRecommendationsModal from './noteRecommendationsModal/actions'
import orderInfoPage from './orderInfoPage/actions'
import ordersStatusPage from './ordersStatusPage/actions'
import productDetailsModal from './productDetailsModal/actions'
import postponedPremiumProduct from './postponedPremiumProduct/actions'
import productPage from './productPage/actions'
import quizPage from './quizPage/actions'
import giftPage from './giftPage/actions'
import incubatorPage from './incubatorPage/actions'
import giftCardPage from './giftCardPage/actions'
import recommendationsPage from './recommendationsPage/actions'
import sentGiftsPage from './sentGiftsPage/actions'
import smartSearchPage from './smartSearchPage/actions'
import reviewsPage from './reviewsPage/actions'
import pickPage from './pickPage/actions'
import cosmeticsPage from './cosmeticsPage/actions'
import searchResultPage from './searchResultPage/actions'
import zodiacSignPage from './zodiacSignPage/actions'
import popularInStatesPage from './popularInStatesPage/actions'
import requestPage from './requestPage/actions'
import fragranceFinderPage from './fragranceFinderPage/actions'
import trackingPage from './trackingPage/actions'
import profilePage from './profilePage/actions'
import makeupLandingPage from './makeupLandingPage/actions'
import skincareIntroPage from './skincareIntroPage/actions'
import navigation from './navigation/actions'
import emptyQueueRecommendationModal from './emptyQueueRecommendationModal/actions'
import fathersDayGiftSetPage from './fathersDayGiftSetPage/actions'
import flashSaleBundlePage from './flashSaleBundlePage/actions'
import caseMonthlyDesignPage from './caseMonthlyDesignPage/actions'
import fragranceConceptsPage from './fragranceConceptsPage/actions'
import queueWidget from './queueWidget/actions'
import improveSurveyPage from './improveSurveyPage/actions'
import shippingAndBillingIssuesModal from './shippingAndBillingIssuesModal/actions'
import improveRecommendationsPage from './improveRecommendationsPage/actions'
import thankYouPage from './thankYouPage/actions'
import referralLandingPage from './referralLandingPage/actions'

import paymentPage from './paymentPage/actions'
import paymentPageNew from './paymentNew/actions'
import redeemQueuePage from './paymentNew/redeemQueuePage/actions'
import redeemTossInPage from './paymentNew/redeemTossInPage/actions'
import subscribePrototypePage from './subscribePrototypePage/actions'


export default {
  brandPage,
  cancelSubscriptionPage,
  careersPage,
  collectionPage,
  collectionLandingPage,
  extrasPage,
  fragranceOfTheMonthPage,
  invitePage,
  mainPage,
  myOrdersPage,
  noteRecommendationsModal,
  orderInfoPage,
  ordersStatusPage,
  productDetailsModal,
  postponedPremiumProduct,
  productPage,
  quizPage,
  giftPage,
  incubatorPage,
  giftCardPage,
  recommendationsPage,
  sentGiftsPage,
  smartSearchPage,
  reviewsPage,
  pickPage,
  cosmeticsPage,
  searchResultPage,
  zodiacSignPage,
  popularInStatesPage,
  requestPage,
  fragranceFinderPage,
  trackingPage,
  profilePage,
  makeupLandingPage,
  skincareIntroPage,
  navigation,
  emptyQueueRecommendationModal,
  flashSaleBundlePage,
  fathersDayGiftSetPage,
  caseMonthlyDesignPage,
  fragranceConceptsPage,
  queueWidget,
  improveSurveyPage,
  shippingAndBillingIssuesModal,
  improveRecommendationsPage,
  thankYouPage,
  referralLandingPage,

  paymentPage,
  paymentPageNew,
  redeemQueuePage,
  redeemTossInPage,
  subscribePrototypePage,
}
